<template>
  <div>
    <el-dialog title="公司简介" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <div>
        <p><span>公司名称：</span>中消云(深圳)数智应急有限公司</p>
        <p><span>公司地址：</span>深圳市光明区新湖街道楼村社区光侨大道3333号新健兴科技工业园A1栋4层</p>
        <p>
          <span>公司简介：</span>中消云（深圳）数智应急有限公司成立于2024-06-06，企业地址位于深圳市光明区新湖街道楼村社区光侨大道3333号新健兴科技工业园A1栋4层，所属行业为科技推广和应用服务业，经营范围包含：一般经营项目是：技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；安防设备销售；信息安全设备销售；安全系统监控服务；信息技术咨询服务；电气设备销售；公共安全管理咨询服务；安全咨询服务；咨询策划服务；消防器材销售；对外承包工程；货物进出口；技术进出口；物联网设备销售；进出口代理；物联网技术研发；物联网应用服务；软件开发；工程管理服务；信息系统集成服务；物联网技术服务；大数据服务；安全技术防范系统设计施工服务。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动），许可经营项目是：建设工程设计；电气安装服务；建设工程施工；雷电防护装置检测；安全评价业务；互联网信息服务。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）。中消云（深圳）数智应急有限公司目前的经营状态为存续。
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    handleOpen() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
p {
  line-height: 26px;
  font-size: 14px;
  position: relative;
  padding-left: 80px;
  margin-bottom: 10px;
}

p span {
  position: absolute;
  left: 0;
  top: 0;
  width: 80px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/companyInfo.vue